// extracted by mini-css-extract-plugin
export var smallSpinner = "_qy-0";